import templateUrl from "emun.invoice/credit-request/credit-request-line-image-actions.htm";
import directive from "emun.invoice/credit-request/credit-request-line.directive";

export default directive(templateUrl);

